import * as Sentry from '@sentry/angular';

export interface BuiltUpSentryConfig {
  enabled: boolean;
  dsn: string;
  environment: string;
  release: string;
}

const SENSITIVE_KEYS = [
  'password',
  'token',
  'access_token',
  'authorization',
  'api_key',
  'apikey',
  'secret',
  'cpf',
];

export function initBuiltUpSentry(config: BuiltUpSentryConfig): void {
  if (!config.enabled || !config.dsn || config.dsn === '__SENTRY_DSN__') {
    return;
  }

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    release: config.release === '__SENTRY_RELEASE__' ? undefined : config.release,
    sendDefaultPii: false,
    maxBreadcrumbs: 50,
    beforeSend(event) {
      if (event.level !== 'error' && event.level !== 'fatal') {
        return null;
      }

      if (event.request?.headers) {
        delete event.request.headers['Authorization'];
        delete event.request.headers['Cookie'];
      }

      if (event.request?.url) {
        event.request.url = redactQueryParams(event.request.url);
      }

      return event;
    },
    initialScope: {
      tags: {
        system: 'builtup',
        component: 'web',
        technology: 'angular',
      },
    },
  });
}

function redactQueryParams(url: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.forEach((_, key) => {
      if (SENSITIVE_KEYS.some((sensitive) => key.toLowerCase().includes(sensitive))) {
        parsed.searchParams.set(key, '[Filtered]');
      }
    });
    return parsed.toString();
  } catch {
    return url;
  }
}

export function createBuiltUpSentryErrorHandler() {
  return Sentry.createErrorHandler({
    showDialog: false,
  });
}
